<div class="stepper-body">
    <div class="body-title">
        <span>Would you like a line of credit or a closed end loan?</span>
    </div>
    <div class="body-description">
        <span>
            <a href="https://www.google.com/search?q=Heloc+or+heloan" target="_blank">Read more about...</a>
        </span>
    </div>
    <div class="body-answers custom-answers">
        <div class="custom-container">
            <button mat-stroked-button class="step-option" [ngClass]="{
                            'selected':isBtnSelected(SecondLienOptions.HELOC)
                        }" (click)="onAnswerSelected(SecondLienOptions.HELOC)">
                {{SecondLienOptions.HELOC}}
            </button>
        </div>
        <div class="custom-container">
            <button mat-stroked-button class="step-option" [ngClass]="{
                            'selected':isBtnSelected(SecondLienOptions.HELOAN)
                        }" (click)="onAnswerSelected(SecondLienOptions.HELOAN)">
                {{SecondLienOptions.HELOAN}}
            </button>
        </div>
    </div>
</div>
<div class="stepper-footer">
    <mat-divider></mat-divider>
    <div class="step-controls">
        <button mat-stroked-button color="primary" (click)="onBack()" class="step-button secondary" [disabled]="false">
            Back
        </button>
        <button mat-flat-button color="primary" (click)="onNext()" class="step-button primary"
            [disabled]="isNextDisabled()">
            Next
        </button>
    </div>
</div>